import GridCard from '../../Components/GridCard'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { tsSample } from '../../Typescript/DB_Interface'

function SampleCards({
  samples,
  detailsActive,
}: {
  samples: tsSample[]
  detailsActive: boolean
}) {
  const navigate = useNavigate()
  return (
    <>
      {samples.map((item) => {
        function onClick() {
          return navigate('/stuart/sample/info/' + item.SampleID)
        }
        if (detailsActive) {
          return (
            <GridCard
              aria-label={'Sample Card'}
              key={item.SampleID}
              onClick={onClick}
              id={item.SampleID}
              size={4}
              title={item.SampleID}
              subtitle={item.LineName}
              attributes={[item.Sex, item.AnimalID]}
            />
          )
        } else {
          return (
            <GridCard
              aria-label={'Sample Card'}
              key={item.SampleID}
              onClick={onClick}
              id={item.SampleID}
              size={3}
              title={item.SampleID}
            />
          )
        }
      })}
    </>
  )
}

export default SampleCards
